import { render, staticRenderFns } from "./HistoriaFamiliar.vue?vue&type=template&id=b2505022&"
import script from "./HistoriaFamiliar.vue?vue&type=script&lang=js&"
export * from "./HistoriaFamiliar.vue?vue&type=script&lang=js&"
import style0 from "./HistoriaFamiliar.vue?vue&type=style&index=0&id=b2505022&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports